import React, { useRef, useState, useEffect, useCallback, useMemo } from 'react';
import { Title } from '@landing/ui';
import { Container } from 'components/UI';
import { Slider } from 'components/UI/Slider';
import SliderControl from 'components/blocks/SliderControl';
import Item from './Item';

import * as styles from './FormerTrainees.module.scss';

function FormerTrainees({ title, items = [], padding = 'Without' }) {
  const sliderRef = useRef(null);
  const [current, setCurrent] = useState(1);
  const [transition, setTransition] = useState(false);

  const enableTransition = () => {
    setTransition(true);
  };

  const disableTransition = () => {
    setTransition(false);
  };

  useEffect(() => {
    if (window.innerWidth <= 375) {
      setCurrent(1);
    }

    if (window.innerWidth <= 768 && window.innerWidth > 375) {
      setCurrent('1 - 2');
    }

    if (window.innerWidth > 768) {
      setCurrent('1 - 3');
    }
  }, []);

  const setCurrentKey = useCallback(
    (prev, next) => {
      enableTransition();
      const slidesOnScreen = sliderRef.current.innerSlider.props.slidesToShow;
      let currentValue;

      switch (slidesOnScreen) {
        case 3:
          currentValue = `${next + 1} - ${next + 3}`;
          break;
        case 2:
          currentValue = next === 8 ? `${next} - ${next + 1}` : `${next + 1} - ${next + 2}`;
          break;
        case 1:
        default:
          currentValue = next + 1;
          break;
      }

      setCurrent(currentValue);
    },
    [sliderRef, current, transition],
  );

  const handleNext = useCallback(() => {
    sliderRef.current.slickNext();
  }, [sliderRef]);

  const handlePrev = useCallback(() => {
    sliderRef.current.slickPrev();
  }, [sliderRef]);

  const settings = useMemo(
    () => ({
      infinite: true,
      speed: 1000,
      slidesToShow: 3,
      slidesToScroll: 3,
      lazyLoad: 'progressive',
      arrows: false,
      responsive: [
        {
          breakpoint: 544,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
      ],
    }),
    [],
  );

  return (
    <Container id="testimonials" padding={padding}>
      <Container theme="inner" background="lightGray">
        <div className={styles.layout}>
          <Title tag="h2" className={styles.title}>
            {title}
          </Title>
          <div className={styles.content}>
            <Slider
              ref={sliderRef}
              beforeChange={setCurrentKey}
              afterChange={disableTransition}
              onSwipe={enableTransition}
              {...settings}
            >
              {items.map(item => (
                <Item key={item.name} {...item} />
              ))}
            </Slider>
            <SliderControl
              className={styles.sliderControls}
              current={current}
              to={items.length}
              handleNext={handleNext}
              handlePrev={handlePrev}
              interval={40}
              transition={transition}
              noOrder
            />
          </div>
        </div>
      </Container>
    </Container>
  );
}

export default FormerTrainees;
